module.exports = require('./helpers/bundle-url').getBundleURL('c9iqF') + "loader1235.7465480d.svg";